document.addEventListener('DOMContentLoaded', function() {
    function iOSDetector() {
      return navigator.userAgent.includes("Mac");
    }

    if (iOSDetector()) {
      const title_shop_i = document.querySelector("._shop section._i ._container ._inside");
      title_shop_i.classList.add('ios');
    }

    var filters = document.querySelectorAll('._filter');
    let select = document.getElementById('sortSelect');
    let card_pdps = Array.from(document.getElementById('cards_pds').getElementsByClassName('_card_pds'));
    let filteredProducts = []; // Almacenar productos filtrados aquí

    filters.forEach(function(filter) {
      filter.addEventListener('click', function() {
        filters.forEach(function(f) {
          f.classList.remove('active');
        });

        this.classList.add('active');
        
        var filterValue = this.getAttribute('data-filter');
        filterProducts(filterValue);
      });
    });

    function filterProducts(filterValue) {
      var products = document.querySelectorAll('._card_pdp');
      filteredProducts = []; // Reiniciar productos filtrados

      products.forEach(function(product) {
        if (filterValue == 'all' || product.getAttribute('data-tags').includes(filterValue)) {
          product.style.display = 'flex';
          filteredProducts.push(product); // Agregar producto a la lista filtrada
        } else {
          product.style.display = 'none';
        }
      });

      // Después del filtrado, aplicar el orden actual
      sortProducts(select.value);
    }

    // Escuchar el cambio en el select
    select.addEventListener('change', function(e) {
        sortProducts(e.target.value);
    });

  
  





  
  
  // Función para ordenar los productos filtrados
    function sortProducts(sortValue) {
      if (filteredProducts.length === 0) {
        filteredProducts = Array.from(document.getElementById('cards_pds').getElementsByClassName('_card_pds'));
      }

      if (sortValue === "best-selling") {
        // Cargar la colección de "Best Sellers" para usarla como referencia de orden
        loadBestSellingProducts().then(bestSellingIds => {
          // Ordenar los productos filtrados basados en la colección de Best Sellers
          filteredProducts.sort(function(a, b) {
            let idA = a.getAttribute('data-product-id');
            let idB = b.getAttribute('data-product-id');

            let indexA = bestSellingIds.indexOf(idA);
            let indexB = bestSellingIds.indexOf(idB);

            if (indexA === -1) indexA = Infinity; // Si no está en la colección, lo mandamos al final
            if (indexB === -1) indexB = Infinity;

            return indexA - indexB; // Ordenar basado en la posición en la colección de Best Sellers
          });

          renderSortedProducts();
        });
      } else {
        // Ordenar por A-Z o Z-A
        filteredProducts.sort(function(a, b) {
          let nameA = a.getAttribute('data-name').toUpperCase();
          let nameB = b.getAttribute('data-name').toUpperCase();

          if (sortValue === "az") {
            return nameA.localeCompare(nameB);
          } else {
            return nameB.localeCompare(nameA);
          }
        });

        renderSortedProducts();
      }
    }

    // Función para cargar los productos de la colección "Best Sellers"
    function loadBestSellingProducts() {
      return fetch('/collections/best-sellers')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const bestSellingProducts = doc.querySelectorAll('#cards_pds ._card_pds');
          
          // Devolver una lista de IDs de productos en la colección "Best Sellers"
          return Array.from(bestSellingProducts).map(product => product.getAttribute('data-product-id'));
        })
        .catch(error => {
          console.error('Error al cargar los productos de best-sellers:', error);
          return [];
        });
    }

    // Función para renderizar los productos ordenados
    function renderSortedProducts() {
      let contenedor = document.getElementById('cards_pds');
      contenedor.innerHTML = ''; // Limpiar el contenedor
      filteredProducts.forEach(product => contenedor.appendChild(product)); // Agregar productos ordenados
    }

    // Aplicar el filtro y orden por defecto al cargar la página
    window.addEventListener('load', function() {
      let defaultSort = document.getElementById('sortSelect').value; // Valor seleccionado por defecto en el select
      sortProducts(defaultSort);
    });
  
  
  
    function switchGridView(isMulti) {
      card_pdps.forEach(card_pdp => {
        if (isMulti) {
          document.querySelector('._shop ._ii ._one ._body ._card_pdps').classList.add('_min-half');
          card_pdp.classList.add('_min-half');
        } else {
          document.querySelector('._shop ._ii ._one ._body ._card_pdps').classList.remove('_min-half');
          card_pdp.classList.remove('_min-half');
        }
      })
    };

    $('.one_square').on('click', () => switchGridView(false));
    $('.grid_square').on('click', () => switchGridView(true));

    function listUrlParams(productUrl, closeBtnColor) {
      var currentUrl = 'https://kochere.com/collections';
      var newUrl = currentUrl + (currentUrl.indexOf('?') !== -1 ? '&' : '?') + 'product=' + productUrl + '&hex=' + closeBtnColor;
      window.history.pushState({path: newUrl}, '', newUrl);
    }
    
    async function showModal(productUrl, closeBtnColor) {

      if (closeBtnColor != '') {
        const hexColor = closeBtnColor.toUpperCase().replace("#", "%23");
        const btnCloseModal = modal.querySelector(".btn-close");
        var svgClose = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.828' height='17.828'%3E%3Cpath d='m2.828 17.828 6.086-6.086L15 17.828 17.828 15l-6.086-6.086 6.086-6.086L15 0 8.914 6.086 2.828 0 0 2.828l6.085 6.086L0 15l2.828 2.828z' fill='${hexColor}'/%3E%3C/svg%3E`;
        btnCloseModal.style.backgroundImage = `url("${svgClose}")`;
      } else {
        const btnCloseModal = modal.querySelector(".btn-close");
        var svgClose = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.828' height='17.828'%3E%3Cpath d='m2.828 17.828 6.086-6.086L15 17.828 17.828 15l-6.086-6.086 6.086-6.086L15 0 8.914 6.086 2.828 0 0 2.828l6.085 6.086L0 15l2.828 2.828z' fill='%23FCB829'/%3E%3C/svg%3E";
        btnCloseModal.style.backgroundImage = `url("${svgClose}")`;
      }

      let response = await fetch(
        productUrl
      );

      let html = await response.text();

      const replacingHTML = await document.querySelector("#modal-section");
      replacingHTML.srcdoc = html;
      
      modal.style.display = "block";
    }

    function closeModal() {
      const modalBody = modal.querySelector('.modal-body');
      modalBody.innerHTML = '';

      const modalSection = document.createElement('iframe');
      modalSection.id = "modal-section";
      modalBody.appendChild(modalSection);
      
      modal.style.display = "none";
      var newUrl = 'https://kochere.com/collections';
      window.history.pushState({path: newUrl}, '', newUrl);
    }
  
    closeBtn.addEventListener("click", function() {
      closeModal()
    });
  
    window.addEventListener("click", function(event) {
        if (event.target == modal) {
            closeModal()
        }
    });
  
    /* END MODAL FUNCTION */

    $(window).on('message', function(event) {
        // Verificar si el mensaje proviene del iframe
        const iframe_modal = document.querySelector('#modal-section');
        if (event.originalEvent.source !== iframe_modal.contentWindow) return;

        // Verificar si el producto se agregó al carrito
        if (event.originalEvent.data.action === 'product_added_to_cart') {
          var newUrl = 'https://kochere.com/collections';
          window.history.pushState({path: newUrl}, '', newUrl);
          closeModal();
        } else if (event.originalEvent.data.action === 'update-cart-quantity') {
          var newQuantity = event.originalEvent.data.value;
          document.querySelector('._header._1 ._icons ._badge').style.display="block";
          document.querySelector('._header._1 .cartMobile ._badge').style.display="block";
          document.querySelector('._header._1 ._icons ._badge').textContent = newQuantity;
          document.querySelector('._header._1 .cartMobile ._badge').textContent = newQuantity;
        }
    });

  /* Show product grid */
  let squareButton = document.querySelector('.one_square');
  let squareGridButton = document.querySelector('.grid_square');

  window.addEventListener('load', () => {
      squareButton.style.background = '#000';
  });
  
  squareButton.addEventListener("click", toggleActive);
  squareGridButton.addEventListener("click", toggleActive);
  
  function toggleActive(event) {
      squareButton.style.background = '';
      squareGridButton.style.background = '';
  
      let children = squareGridButton.querySelectorAll('*');
      for (let child of children) {
          child.style.background = '';
      }
  
      if (event.target === squareButton) {
          event.target.style.background = '#000';
      } else if (event.target === squareGridButton || squareGridButton.contains(event.target)) {
          for (let child of children) {
            child.style.background = '#000';
          }
      }
  }

});
